import styled, { css } from 'styled-components';

export const GalleryWrapper = styled.div<{ $overlay?: boolean }>(
  ({ theme, $overlay }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s2};
    margin-top: ${theme.sz.s6};

    ${
      $overlay &&
      css`
        [data-testid='mem-gallery-title'] {
          ${theme.typography.paragraph.s};
          color: ${theme.co.neutral90};
          text-transform: none;
          letter-spacing: normal;
        }

        [data-testid='mem-gallery-view-all'],
        [data-testid='mem-gallery-info'] button {
          color: ${theme.co.neutral90};

          &:hover {
            color: ${theme.co.neutral99};
          }
        }
      `
    }
  `,
);

export const GalleryTitle = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    color: ${theme.co.neutral40};
    text-transform: uppercase;
    letter-spacing: 0.05em;
  `,
);

export const TitleRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s1};
  `,
);

export const TitleInfoIcon = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex-shrink: 0;

    button {
      margin-left: 0;
      font-size: ${theme.sz.s4};
      color: ${theme.co.neutral40};
    }

    button:hover {
      color: ${theme.co.neutral20};
    }
  `,
);

export const ViewAllMemsButton = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${theme.sz.s6};
    height: ${theme.sz.s6};
    padding: 0;
    border: none;
    border-radius: ${theme.bo.small};
    background: none;
    color: ${theme.co.neutral40};
    cursor: pointer;

    &:hover {
      color: ${theme.co.neutral20};
    }

    &:focus-visible {
      outline: ${theme.bo.mediumWidth} solid ${theme.co.success40};
      outline-offset: ${theme.sz.s1};
    }
  `,
);

export const AllMemsList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: ${theme.sz.s2};
    width: min(90vw, 460px);
    max-height: 70vh;
    overflow-y: auto;
    padding: ${theme.sz.s6};
  `,
);

export const ScrollContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.sz.s2};
    overflow-x: auto;
    padding-bottom: ${theme.sz.s1};
    scroll-snap-type: x mandatory;

    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.co.neutral95};
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.co.neutral80};
      border-radius: 2px;
    }

    & > * {
      scroll-snap-align: start;
    }
  `,
);
